import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const purchases = [{
  name: 'María García',
  combo: 'Guía para Hacer Esquejes',
  city: 'Bogotá',
  country: 'Colombia'
}, {
  name: 'Carlos Rodríguez',
  combo: 'Propagación Completa',
  city: 'Buenos Aires',
  country: 'Argentina'
}, {
  name: 'Andrea López',
  combo: 'Producción Comercial',
  city: 'Ciudad de México',
  country: 'México'
}, {
  name: 'Juan Martínez',
  combo: 'Guía para Hacer Esquejes',
  city: 'Lima',
  country: 'Perú'
}, {
  name: 'Camila Fernández',
  combo: 'Propagación Completa',
  city: 'Santiago',
  country: 'Chile'
}, {
  name: 'Diego Herrera',
  combo: 'Producción Comercial',
  city: 'Medellín',
  country: 'Colombia'
}, {
  name: 'Valentina Muñoz',
  combo: 'Guía para Hacer Esquejes',
  city: 'Montevideo',
  country: 'Uruguay'
}, {
  name: 'Sebastián Ríos',
  combo: 'Propagación Completa',
  city: 'Guadalajara',
  country: 'México'
}, {
  name: 'Catalina Vargas',
  combo: 'Producción Comercial',
  city: 'Quito',
  country: 'Ecuador'
}, {
  name: 'Andrés Morales',
  combo: 'Guía para Hacer Esquejes',
  city: 'Caracas',
  country: 'Venezuela'
}, {
  name: 'Fernanda Silva',
  combo: 'Propagación Completa',
  city: 'São Paulo',
  country: 'Brasil'
}, {
  name: 'Laura Castillo',
  combo: 'Guía para Hacer Esquejes',
  city: 'Cali',
  country: 'Colombia'
}, {
  name: 'Matías Rojas',
  combo: 'Producción Comercial',
  city: 'Córdoba',
  country: 'Argentina'
}, {
  name: 'Daniela Ospina',
  combo: 'Propagación Completa',
  city: 'La Paz',
  country: 'Bolivia'
}, {
  name: 'Nicolás Araya',
  combo: 'Guía para Hacer Esquejes',
  city: 'Asunción',
  country: 'Paraguay'
}];
function getTimeAgo(): string {
  const minutes = Math.floor(Math.random() * 45) + 2;
  return `hace ${minutes} min`;
}
export function SocialProofPopup() {
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    // Show first popup after 8 seconds
    const initialTimer = setTimeout(() => {
      if (!isDismissed) {
        setCurrentIndex(0);
        setIsVisible(true);
      }
    }, 8000);
    return () => clearTimeout(initialTimer);
  }, [isDismissed]);
  useEffect(() => {
    if (currentIndex < 0 || isDismissed) return;
    // Hide after 5 seconds
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 5000);
    // Show next after 15-25 seconds
    const nextTimer = setTimeout(() => {
      const nextIndex = (currentIndex + 1) % purchases.length;
      setCurrentIndex(nextIndex);
      setIsVisible(true);
    }, Math.random() * 10000 + 15000);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, [currentIndex, isDismissed]);
  const current = currentIndex >= 0 ? purchases[currentIndex] : null;
  if (isDismissed || !current) return null;
  return <AnimatePresence data-id="element-213">
      {isVisible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 20,
      stiffness: 300
    }} className="fixed bottom-24 lg:bottom-6 left-4 z-40 max-w-xs" data-id="element-214">
          <div className="bg-white rounded-xl shadow-2xl border border-gray-100 p-4 relative" data-id="element-215">
            <button onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-216">
              <X className="w-3.5 h-3.5" data-id="element-217" />
            </button>

            <div className="flex items-start gap-3 pr-4" data-id="element-218">
              <div className="w-10 h-10 rounded-full bg-[#4a7c2c]/10 flex items-center justify-center flex-shrink-0" data-id="element-219">
                <ShoppingBag className="w-5 h-5 text-[#4a7c2c]" data-id="element-220" />
              </div>
              <div className="min-w-0" data-id="element-221">
                <p className="text-sm font-bold text-gray-900 leading-tight" data-id="element-222">
                  {current.name}
                </p>
                <p className="text-xs text-gray-600 mt-0.5" data-id="element-223">
                  adquirió{' '}
                  <span className="font-semibold text-[#4a7c2c]" data-id="element-224">
                    {current.combo}
                  </span>
                </p>
                <p className="text-[10px] text-gray-400 mt-1" data-id="element-225">
                  {current.city}, {current.country} · {getTimeAgo()}
                </p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}